import React from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';

export function PageHeader({ title, subtitle, buttonLabel, onButtonClick, buttonIcon: Icon = FaPlus, children }) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h1 className="mb-0">{title}</h1>
        {subtitle && <small className="text-muted">{subtitle}</small>}
      </div>
      <div className="d-flex gap-2 align-items-center">
        {children}
        {buttonLabel && (
          <Button variant="primary" onClick={onButtonClick}>
            <Icon className="me-2" /> {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
